import { animate, state, style, transition, trigger } from '@angular/animations';
import { DOCUMENT } from '@angular/common';
import { Component, Inject, Input, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { QuillEditorComponent } from 'ngx-quill';
import { environment } from '../../../../../environments/environment';
import { CampaignService, UtilService, VariablesService } from '../../../../shared/services';

@Component({
  selector: 'app-editor',
  animations: [
    trigger('optionState', [
      state('inactive', style({
        overflow: 'hidden',
      })),
      state('active', style({
        overflow: 'hidden',
      })),
      transition('inactive => active', [
        style({ height: 0 }),
        animate('500ms ease-in-out')
      ]),
      transition('active => inactive', [
        style({ height: 0 }),
        animate('500ms ease-in-out')
      ])
    ])
  ],
  templateUrl: './editor.component.html',
  styleUrls: ['./editor.component.scss']
})
export class EditorComponent implements OnInit {

  @Input() public group: FormGroup;
  @Input() public control: FormControl;
  @Input() public info;
  @Input() public draftId;
  @Input() public draftData;
  @ViewChild('editor', { static: true }) public editor: QuillEditorComponent;
  @ViewChild('placeholder') public placeholder;
  public state = 'inactive';
  public options = false;
  imageUploading = false;

  public editorStyleObject = {
    'min-height': '250px',
    'width': '100%',
    'height': '100%'
  };

  constructor(
    public campaignService: CampaignService,
    @Inject(DOCUMENT) private document: any,
    private util: UtilService,
    private vars: VariablesService
  ) { }

  ngOnInit() {
    this.util.addCssToGlobal('https://cdn.quilljs.com/1.3.6/quill.snow.css');
  }

  /**Editor focus */
  setFocus(event: any) {
    event.focus();
    this.imageHanlder(event);
    this.plaintextOnly(event);
  }

  /**Add match for plain text only */
  plaintextOnly(editorInstance) {
    editorInstance.clipboard.addMatcher(Node.ELEMENT_NODE, (node, delta) => {
      delta.ops = delta.ops.map(op => {
        return {
          insert: op.insert
        };
      });
      return delta;
    });
  }

  /**Toggle editor options */
  toggleOptions() {
    this.state = this.state === 'active' ? 'inactive' : 'active';
    this.options = !this.options;
  }

  /**Undo redo */
  history(action) {
    action === 'undo' ? this.editor.quillEditor.history.undo() : this.editor.quillEditor.history.redo();
  }

  /**Upload image handler */
  imageHanlder(editor) {
    const _this = this;
    // quill editor add image handler
    editor.getModule('toolbar').addHandler('image', () => {
      selectLocalImage();
    });
    /**
     * Step1. select local image
     */
    function selectLocalImage() {
      const input = _this.document.createElement('input');
      input.setAttribute('type', 'file');
      input.click();
      // Listen upload local image and save to server
      input.onchange = () => {
        const file = input.files[0];
        // file type is only image.
        if (/^image\//.test(file.type)) {
          saveToServer(file);
        } else {
          console.warn('You could only upload images.');
        }
      };
    }
    /**
     * Step2. save to server
     * @param {File} file
     */
    function saveToServer(file: File) {
      const payload = new FormData();
      payload.append('file', file);
      _this.imageUploading = true;
      _this.campaignService.uploadEditorImage(payload, _this.draftId).subscribe((res: any) => {
        const url = environment.APP.IMAGE_DOMAIN + res.path + res.name;
        insertToEditor(url);
        const isMedical = _this.vars.ALL_MEDICAL_CAUSES.includes(_this.draftData.cause_id) ? true : false;
        if(isMedical){
          _this.util.openSnackBar('Images of kids will be blurred as per Govt Regulation', 'success');
        }
      },(err) => {
        _this.imageUploading = false;
      });
    }
    /**
     * Step3. insert image url to rich editor.
     * @param {string} url
     */
    function insertToEditor(url: string) {
      // push image url to rich editor.
      const range = editor.getSelection();
      editor.insertEmbed(range?.index, 'image', url);
      _this.imageUploading = false;
    }
  }

}
